'use strict'; // 核心

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _jquery = _interopRequireDefault(require("jquery"));

var _component = _interopRequireDefault(require("../core/component"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

//import Enhance from '../core/enhance';
//
//import {is_function} from '../libs/tools'

/**
 * 父组件更新时Lock组件不会一起更新
 * 必须调用Lock组件对象的update来更新Lock组件的子节点
 */
var Lock = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Lock, _Component);

  /**
   *
   * @param props
   * @param context
   */
  function Lock(props, context) {
    var _this;

    _this = _Component.call(this, props, context) || this;
    _this.state = {
      children: null
    };

    _this.update = function (children, callback) {
      var time = new Date().getTime();

      _this.setState({
        time: time,
        children: children
      }, callback);
    };

    _jquery.default.extend(_this.state, props);

    return _this;
  }
  /**
   *shouldComponentUpdate(object nextProps, object nextState): boolean
   * 当组件做出是否要更新DOM的决定的时候被调用。
   * 实现该函数，优化this.props和nextProps，以及this.state和nextState的比较，
   * 如果不需要React更新DOM，则返回false。
   */


  var _proto = Lock.prototype;

  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
    _jquery.default.extend(this.state, nextProps);

    if (this.state.time != nextState.time) return true;
    return !(nextProps.autoRender === false) || !(this.props.autoRender === false);
  }
  /**
   *
   * @returns {null}
   */
  ;

  _proto.render = function render() {
    return this.state.children;
  }
  /**
   *
   * @param children
   */
  ;

  return Lock;
}(_component.default);
/**
 *
 */
//Enhance(Lock, {
//    defaultProps: {
//        autoRender: false
//    }
//}, 'Lock');


Lock.displayName = "Lock";
Lock.defaultProps = {
  autoRender: false
};
var _default = Lock;
exports.default = _default;
module.exports = exports.default;